import { memo, ReactNode } from "react"
import "./lesson-background.less"
import { Theme } from "models/tables"

type Props = {
  isBusinessVersion: boolean
  theme: Theme | null
  foreground?: ReactNode
  background?: ReactNode
}

const LessonBackground = memo<Props>(function LessonBackground(props: Props) {
  const { isBusinessVersion } = props

  //console.log("business", isBusinessVersion)
  if (props.theme !== null) {
    console.log(props.theme, props.theme.backgroundUrl)
    return (
      <div
        className="w-100 h-100 position-absolute"
        style={{
          backgroundImage: `url(${props.theme.backgroundUrl})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundPosition: "center",
        }}
      ></div>
    )
  }

  return (
    <div className="lesson-background">
      {props.background}

      <div className="cloud c1" />
      <div className="cloud c2 extra" />

      <div className="cloud c3" />
      <div className="cloud c4" />

      <div className="cloud c5 extra" />
      <div className="cloud c6" />

      {!isBusinessVersion && (
        <div className="bee">
          <div className="wing-1" />
          <div className="wing-2" />
        </div>
      )}

      <div className="tree extra left-1" />
      <div className="tree left-2" />
      <div className="tree extra right-1" />
      <div className="tree right-2" />

      {!isBusinessVersion && (
        <div className="ladybug">
          <div className="wings">
            <div className="small_wing" />
            <div className="wing-1" />
            <div className="wing-2" />
          </div>
        </div>
      )}

      {props.foreground}
    </div>
  )
})

export default LessonBackground
